import { ChangeDetectionStrategy, Component, HostBinding, OnInit } from '@angular/core';

import { SitecoreEventDetailsConfig } from '@frontend/sports/common/client-config-data-access';
import { TooltipModule } from '@frontend/sports/tooltip-feature';
import { LocalStoreService } from '@frontend/vanilla/core';

import { EventSwitcherStore } from '../models';

@Component({
    selector: 'ms-event-switcher-onboarding',
    templateUrl: './event-switcher-onboarding.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TooltipModule],
})
export class EventSwitcherOnboardingComponent implements OnInit {
    @HostBinding('class') className = `event-switcher-help`;
    showHelp = false;

    constructor(
        private localStoreService: LocalStoreService,
        public sitecoreEventDetails: SitecoreEventDetailsConfig,
    ) {}

    ngOnInit(): void {
        this.checkOnBoarding();
    }

    private checkOnBoarding(): void {
        const eventSwitcherStore = this.localStoreService.get<EventSwitcherStore>('eventSwitcher') || { helpShown: false };
        this.showHelp = !eventSwitcherStore.helpShown;

        if (this.showHelp) {
            this.localStoreService.set<EventSwitcherStore>('eventSwitcher', { helpShown: true });
        }
    }
}
